<template>
  <div class="container">
    <div class="tile">
      <div class="tile-content">
        <form class="form-horizontal" v-on:submit="save">
          <div class="form-group">
             <div class="container">
            <div class="columns">
              <div class="col-5 col-md-12">
                <label class="form-label">{{question.text}}</label>
              </div>
              <div class="col-2 col-md-12">
                <label class="form-radio" @click.prevent="quickSave('y')">
                  <input type="radio" :name="question.ref" v-model="answer.atxt" value="y" />
                  <i class="form-icon"></i> Yes
                </label>
                <label class="form-radio" @click.prevent="quickSave('n')">
                  <input type="radio" :name="question.ref" v-model="answer.atxt" value="n" />
                  <i class="form-icon"></i> No
                </label>
              </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
export default {
  name: 'boolQ',
  extends: baseQ
}
</script>



// WEBPACK FOOTER //
// bool.vue?8c0d115e